export default __webpack_public_path__ + "images/pay_f76fe2.png";